/* Lilac Love UGC videos · assets/ll-ugc-common.js
   Shared by ll-ugc-cards.js and ll-ugc-floating.js. Provides: small utilities,
   the short muted "preview" behaviour used by both a card and the floating
   button, and the popup player (Viewer + Slide). Load this file before the
   other two; it defines window.LLUgcCore and does nothing on its own. */
(function () {
  'use strict';
  if (window.LLUgcCore) return;

  var rmq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false, addEventListener: function () {} };
  function reduced() { return !!rmq.matches; }
  function noop() {}
  function dataSaver() {
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    return !!(c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || '')));
  }
  function designMode() { return !!(window.Shopify && window.Shopify.designMode); }
  function store(kind) { try { return window[kind]; } catch (e) { return null; } }
  function getJSON(kind, key, d) { try { var s = store(kind); return s ? JSON.parse(s.getItem(key) || 'null') || d : d; } catch (e) { return d; } }
  function setJSON(kind, key, v) { try { var s = store(kind); if (s) s.setItem(key, JSON.stringify(v)); } catch (e) {} }
  function tryPlay(v, onFail) {
    var p; try { p = v.play(); } catch (e) { if (onFail) onFail(e); return; }
    if (p && p.catch) p.catch(function (e) { if (onFail) onFail(e); });
  }
  function fmt(t) { if (!isFinite(t) || t < 0) return '0:00'; var m = Math.floor(t / 60), s = Math.floor(t % 60); return m + ':' + (s < 10 ? '0' : '') + s; }

  var safeProbeEl = null;
  function safeInsets() {
    if (!safeProbeEl) {
      safeProbeEl = document.createElement('div');
      safeProbeEl.style.cssText = 'position:fixed;inset:0;visibility:hidden;pointer-events:none;' +
        'padding:env(safe-area-inset-top,0px) env(safe-area-inset-right,0px) env(safe-area-inset-bottom,0px) env(safe-area-inset-left,0px)';
      document.body.appendChild(safeProbeEl);
    }
    var c = getComputedStyle(safeProbeEl);
    return { top: parseFloat(c.paddingTop) || 0, right: parseFloat(c.paddingRight) || 0, bottom: parseFloat(c.paddingBottom) || 0, left: parseFloat(c.paddingLeft) || 0 };
  }

  /* ------------------------------------------------------------------
     Preview: the short muted loop used on a card's thumbnail and on the
     floating button. `host` just needs an `.on(target, evt, fn)` method
     (an AbortController-backed listener registrar) and a way to say
     whether previews are currently allowed (data saver / reduced motion
     already factored in by the caller via `allowed()`).
     ------------------------------------------------------------------ */
  function Preview(host, video, opts) {
    this.host = host; this.video = video; this.opts = opts || {};
    this.playing = false; this.bound = false; this.loop_ = true;
  }
  Preview.prototype.start = function (src, start, seconds, onLive, loop) {
    var v = this.video, self = this;
    if (!v || !src) return;
    this.onLive = onLive;
    this.start_ = start || 0; this.end_ = this.start_ + (seconds || 3);
    this.loop_ = loop !== false;
    var want = src + '#t=' + this.start_ + ',' + this.end_;
    v.muted = true; v.loop = false; v.preload = 'metadata';
    if (v.getAttribute('src') !== want) v.src = want;
    if (!this.bound) {
      this.bound = true;
      this.host.on(v, 'timeupdate', function () {
        if (!self.playing || v.currentTime < self.end_ - 0.08) return;
        if (self.loop_) { v.currentTime = self.start_; }
        else { self.playing = false; try { v.pause(); } catch (e) {} if (self.onLive) self.onLive(false); }
      });
      this.host.on(v, 'ended', function () { if (self.playing && self.loop_) { v.currentTime = self.start_; tryPlay(v); } });
      this.host.on(v, 'playing', function () { if (self.onLive) self.onLive(true); });
    }
    this.playing = true;
    tryPlay(v, function () { self.playing = false; if (self.onLive) self.onLive(false); });
  };
  Preview.prototype.stop = function (onLive) {
    if (!this.playing) return;
    this.playing = false;
    try { this.video.pause(); } catch (e) {}
    if (onLive) onLive(false); else if (this.onLive) this.onLive(false);
  };

  /* ------------------------------------------------------------------
     Slide: one video inside the popup feed.
     ------------------------------------------------------------------ */
  function Slide(viewer, item, index, total) {
    var self = this, host = viewer.host;
    this.viewer = viewer; this.item = item; this.index = index;
    this.userPaused = false; this.loaded = false;
    var el = this.el = document.createElement('section');
    el.className = 'll-slide'; el.setAttribute('role', 'group'); el.setAttribute('aria-roledescription', 'slide');
    el.setAttribute('aria-label', (index + 1) + ' / ' + total);
    el.setAttribute('data-empty', String(!item.hasSrc)); el.setAttribute('data-started', 'false'); el.setAttribute('data-loading', 'false'); el.setAttribute('data-error', 'false');
    el.innerHTML =
      '<div class="ll-slide__media">' +
        '<video class="ll-slide__video" playsinline preload="none" muted disablepictureinpicture></video>' +
        (item.thumb ? '<img class="ll-slide__poster" alt="" decoding="async">' : '') +
        '<button type="button" class="ll-slide__tap"></button>' +
        '<span class="ll-slide__flash" aria-hidden="true"></span>' +
        '<div class="ll-slide__status" role="status"><span class="ll-spin" aria-hidden="true"></span><span class="ll-sr"></span></div>' +
        '<div class="ll-slide__err" role="alert"><p></p><button type="button" data-retry></button></div>' +
        '<p class="ll-slide__empty"></p>' +
      '</div><div class="ll-slide__ui"></div>';
    this.video = el.querySelector('video'); this.poster = el.querySelector('.ll-slide__poster'); this.tapBtn = el.querySelector('.ll-slide__tap');
    this.flash = el.querySelector('.ll-slide__flash');
    var P = viewer.pop;
    el.querySelector('.ll-sr').textContent = P.getAttribute('data-l-loading') || 'Loading video';
    el.querySelector('.ll-slide__err p').textContent = P.getAttribute('data-l-error') || "This video couldn't play.";
    el.querySelector('[data-retry]').textContent = P.getAttribute('data-l-retry') || 'Try again';
    el.querySelector('.ll-slide__empty').textContent = P.getAttribute('data-l-empty') || '';
    if (this.poster) this.poster.src = item.thumb;
    var tpl = item.el.querySelector('template[data-slide]');
    if (tpl && tpl.content) el.querySelector('.ll-slide__ui').appendChild(tpl.content.cloneNode(true));
    this.syncLabel();

    var v = this.video;
    host.on(this.tapBtn, 'click', function () { self.toggle(); });
    host.on(el.querySelector('[data-retry]'), 'click', function () { self.setFlag('error', false); v.load(); self.userPaused = false; self.play(); });
    host.on(v, 'play', function () { self.setFlag('started', true); self.setFlag('error', false); self.syncLabel(); });
    host.on(v, 'playing', function () { self.setFlag('loading', false); });
    host.on(v, 'canplay', function () { self.setFlag('loading', false); });
    host.on(v, 'waiting', function () { if (!v.paused) self.setFlag('loading', true); });
    host.on(v, 'pause', function () { self.setFlag('loading', false); self.syncLabel(); });
    host.on(v, 'error', function () { if (v.getAttribute('src')) { self.setFlag('error', true); self.setFlag('loading', false); } });
    host.on(v, 'ended', function () { if (viewer.endAction === 'next') viewer.next(true); });
  }
  Slide.prototype.setFlag = function (n, val) { this.el.setAttribute('data-' + n, String(!!val)); };
  Slide.prototype.syncLabel = function () {
    var P = this.viewer.pop, v = this.video, playing = !v.paused && !v.ended;
    var word = playing ? (P.getAttribute('data-l-pause') || 'Pause video') : (P.getAttribute('data-l-play') || 'Play video');
    this.tapBtn.setAttribute('aria-label', word + ': ' + this.item.title);
  };
  Slide.prototype.load = function (eager) {
    var v = this.video; if (!this.item.hasSrc) return;
    if (v.getAttribute('src') !== this.item.srcFull) v.src = this.item.srcFull;
    v.preload = eager ? 'auto' : 'metadata'; this.loaded = true;
  };
  Slide.prototype.unload = function () {
    if (!this.loaded) return;
    var v = this.video; try { v.pause(); } catch (e) {}
    v.removeAttribute('src'); try { v.load(); } catch (e) {}
    this.loaded = false; this.setFlag('started', false);
  };
  Slide.prototype.play = function () {
    var v = this.video, self = this, vw = this.viewer;
    if (!this.item.hasSrc) return;
    this.load(true); this.setFlag('error', false);
    v.loop = vw.endAction === 'loop'; v.muted = vw.muted;
    if (v.readyState < 3) this.setFlag('loading', true);
    tryPlay(v, function (e) {
      if (e && e.name === 'AbortError') return;
      if (e && e.name === 'NotAllowedError' && !v.muted) { vw.setMuted(true); tryPlay(v, function () { self.setFlag('loading', false); }); return; }
      if (e && e.name === 'NotAllowedError') { self.setFlag('loading', false); return; }
      self.setFlag('error', true); self.setFlag('loading', false);
    });
  };
  Slide.prototype.pause = function () { try { this.video.pause(); } catch (e) {} };
  Slide.prototype.toggle = function () {
    if (!this.item.hasSrc) return;
    var v = this.video, pausing = !v.paused;
    if (pausing) { this.userPaused = true; this.pause(); } else { this.userPaused = false; this.play(); }
    var f = this.flash; if (!f) return;
    f.innerHTML = '<svg class="ico" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' + (pausing
      ? '<rect x="6" y="5" width="4.2" height="14" rx="1.2"/><rect x="13.8" y="5" width="4.2" height="14" rx="1.2"/>'
      : '<path d="M8 5.5v13a1 1 0 0 0 1.5.86l10.5-6.5a1 1 0 0 0 0-1.72L9.5 4.64A1 1 0 0 0 8 5.5z"/>') + '</svg>';
    f.classList.remove('is-on'); void f.offsetWidth; f.classList.add('is-on');
  };

  /* ------------------------------------------------------------------
     Viewer: the popup player. `host` is the owning Section (Cards or
     Floating); it supplies `.items`, `.on()`, `.emit()`, `.str()`, and is
     told about open/close so it can pause its own previews.
     ------------------------------------------------------------------ */
  function Viewer(host, pop) {
    var self = this;
    this.host = host; this.pop = pop; this.isOpen = false; this.built = false; this.slides = []; this.active = -1; this.pushed = false; this.raf = 0;
    this.feed = pop.querySelector('[data-feed]'); this.dialog = pop.querySelector('[data-pop-dialog]');
    this.btnClose = pop.querySelector('[data-pop-close]'); this.btnMute = pop.querySelector('[data-pop-mute]');
    this.btnPrev = pop.querySelector('[data-pop-prev]'); this.btnNext = pop.querySelector('[data-pop-next]');
    this.progress = pop.querySelector('[data-progress-line] span');
    this.muted = pop.getAttribute('data-sound') !== 'sound';
    this.endAction = pop.getAttribute('data-end') || 'loop';
    this.preload = parseInt(pop.getAttribute('data-preload'), 10); if (isNaN(this.preload)) this.preload = 1;
    this.backCloses = pop.getAttribute('data-back') !== 'false';
    this.backdropClose = pop.getAttribute('data-backdrop-close') !== 'false';
    this.showProgress = pop.getAttribute('data-show-progress') === 'true';
    pop.style.cssText = host.styleText || '';
    removeStale(pop.parentNode ? null : document.body, '.ll-pop', host.owner);
    pop.setAttribute('data-owner', host.owner);
    document.body.appendChild(pop);
    this.setMuted(this.muted);

    host.on(this.btnClose, 'click', function () { self.close(); });
    host.on(this.btnMute, 'click', function () { self.setMuted(!self.muted); });
    host.on(this.btnPrev, 'click', function () { self.prev(); });
    host.on(this.btnNext, 'click', function () { self.next(); });
    host.on(pop.querySelector('[data-pop-backdrop]'), 'click', function () { if (self.backdropClose) self.close(); });
    host.on(pop, 'click', function (e) { if (self.backdropClose && e.target === pop) self.close(); });
    host.on(this.feed, 'click', function (e) {
      var a = e.target.closest && e.target.closest('a[data-product]');
      if (a) host.emit('product-click', { url: a.href, title: (self.slides[self.active] || {}).item ? self.slides[self.active].item.title : '' });
    });
    host.on(document, 'keydown', function (e) { self.onKey(e); });
    host.on(window, 'popstate', function () { if (self.isOpen) { self.pushed = false; self.hide(); } });
    host.on(window, 'resize', function () { if (self.isOpen && self.active > -1) self.goTo(self.active, false); }, { passive: true });
  }
  function removeStale(scope, sel, owner) {
    [].forEach.call(document.querySelectorAll('body > ' + sel + '[data-owner]'), function (n) { if (n.getAttribute('data-owner') === owner && n.parentNode) n.parentNode.removeChild(n); });
  }
  Viewer.prototype.build = function () {
    if (this.built) return; this.built = true;
    var self = this, items = this.host.items;
    items.forEach(function (it, i) {
      var s = new Slide(self, it, i, items.length);
      self.slides.push(s); self.feed.appendChild(s.el);
    });
    if ('IntersectionObserver' in window) {
      this.io = new IntersectionObserver(function (entries) {
        if (!self.isOpen) return;
        entries.forEach(function (en) {
          if (en.isIntersecting && en.intersectionRatio >= 0.6) self.activate(self.slides.map(function (s) { return s.el; }).indexOf(en.target));
        });
      }, { root: this.feed, threshold: [0.6] });
      this.slides.forEach(function (s) { self.io.observe(s.el); });
    }
  };
  Viewer.prototype.setMuted = function (m) {
    this.muted = m; this.pop.setAttribute('data-muted', String(m));
    var P = this.pop;
    this.btnMute.setAttribute('aria-label', m ? (P.getAttribute('data-l-unmute') || 'Unmute video') : (P.getAttribute('data-l-mute') || 'Mute video'));
    this.slides.forEach(function (s) { s.video.muted = m; });
  };
  Viewer.prototype.lock = function () {
    var de = document.documentElement, b = document.body;
    this.saved = [de.style.overflow, b.style.overflow, de.style.paddingRight];
    var sw = window.innerWidth - de.clientWidth;
    de.style.overflow = 'hidden'; b.style.overflow = 'hidden'; if (sw > 0) de.style.paddingRight = sw + 'px';
    de.classList.add('ll-ugc-open');
  };
  Viewer.prototype.unlock = function () {
    var de = document.documentElement, b = document.body;
    if (this.saved) { de.style.overflow = this.saved[0]; b.style.overflow = this.saved[1]; de.style.paddingRight = this.saved[2]; this.saved = null; }
    de.classList.remove('ll-ugc-open');
  };
  Viewer.prototype.open = function (index, trigger) {
    if (this.isOpen || !this.host.items.length) return;
    if (window.LLUgcCore.activeViewer && window.LLUgcCore.activeViewer !== this) { window.LLUgcCore.activeViewer.pushed = false; window.LLUgcCore.activeViewer.hide(); }
    window.LLUgcCore.activeViewer = this;
    document.dispatchEvent(new CustomEvent('ll-ugc:pause-background'));
    this.build(); this.trigger = trigger || null; this.isOpen = true;
    this.pop.hidden = false; this.lock();
    this.active = -1;
    this.feed.style.scrollSnapType = 'none';
    this.feed.scrollTop = index * this.feed.clientHeight;
    this.feed.style.scrollSnapType = '';
    this.activate(index);
    try { this.btnClose.focus({ preventScroll: true }); } catch (e) { this.btnClose.focus(); }
    if (this.backCloses) { try { history.pushState({ llUgc: 1 }, ''); this.pushed = true; } catch (e) {} }
    this.host.onViewerToggle(true);
    this.host.emit('open', { index: index, title: this.host.items[index].title });
    if (this.showProgress) this.tickProgress();
  };
  Viewer.prototype.close = function () {
    if (!this.isOpen) return;
    var wasPushed = this.pushed; this.pushed = false;
    this.hide();
    if (wasPushed) { try { history.back(); } catch (e) {} }
  };
  Viewer.prototype.hide = function () {
    if (!this.isOpen) return;
    this.isOpen = false; this.pop.hidden = true;
    if (window.LLUgcCore.activeViewer === this) window.LLUgcCore.activeViewer = null;
    cancelAnimationFrame(this.raf);
    this.slides.forEach(function (s) { s.pause(); s.userPaused = false; });
    this.active = -1;
    this.unlock();
    var t = this.trigger; this.trigger = null;
    if (t && document.contains(t)) { try { t.focus({ preventScroll: true }); } catch (e) {} }
    this.host.onViewerToggle(false);
    this.host.emit('close', {});
  };
  Viewer.prototype.activate = function (i) {
    if (i < 0 || i >= this.slides.length || i === this.active) return;
    var prev = this.slides[this.active]; if (prev) { prev.pause(); prev.userPaused = false; }
    this.active = i;
    var s = this.slides[i], pre = this.preload;
    s.play();
    this.slides.forEach(function (sl, j) {
      var d = Math.abs(j - i);
      if (j !== i && d <= pre) sl.load(d === 1 && j > i);
      else if (d > pre + 1) sl.unload();
    });
    this.updateNav();
    this.host.emit('view', { index: i, title: s.item.title });
  };
  Viewer.prototype.goTo = function (i, smooth) {
    if (i < 0 || i >= this.slides.length) return;
    this.feed.scrollTo({ top: i * this.feed.clientHeight, behavior: (smooth && !reduced()) ? 'smooth' : 'auto' });
  };
  Viewer.prototype.next = function (fromEnd) { if (this.active < this.slides.length - 1) this.goTo(this.active + 1, true); else if (fromEnd) { var s = this.slides[this.active]; if (s) s.video.currentTime = 0; } };
  Viewer.prototype.prev = function () { if (this.active > 0) this.goTo(this.active - 1, true); };
  Viewer.prototype.updateNav = function () {
    var last = this.slides.length - 1;
    if (this.btnPrev) this.btnPrev.setAttribute('aria-disabled', String(this.active <= 0));
    if (this.btnNext) this.btnNext.setAttribute('aria-disabled', String(this.active >= last));
  };
  Viewer.prototype.tickProgress = function () {
    var self = this;
    cancelAnimationFrame(this.raf);
    var loop = function () {
      if (!self.isOpen) return;
      var s = self.slides[self.active];
      if (s && self.progress && s.video.duration > 0) self.progress.style.transform = 'scaleX(' + Math.min(1, s.video.currentTime / s.video.duration) + ')';
      self.raf = requestAnimationFrame(loop);
    };
    this.raf = requestAnimationFrame(loop);
  };
  Viewer.prototype.onKey = function (e) {
    if (!this.isOpen) return;
    var k = e.key, tag = (e.target && e.target.tagName) || '';
    if (k === 'Escape') { e.preventDefault(); this.close(); return; }
    if (k === 'Tab') {
      var f = [].filter.call(this.pop.querySelectorAll('button:not([disabled]),a[href],[tabindex]:not([tabindex="-1"])'), function (n) { return n.getClientRects().length && n.getAttribute('aria-disabled') !== 'true'; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1], cur = document.activeElement;
      if (!this.pop.contains(cur)) { e.preventDefault(); first.focus(); }
      else if (e.shiftKey && cur === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && cur === last) { e.preventDefault(); first.focus(); }
      return;
    }
    if (e.altKey || e.ctrlKey || e.metaKey || /^(INPUT|TEXTAREA|SELECT)$/.test(tag) || e.target.isContentEditable) return;
    if (k === 'ArrowDown' || k === 'PageDown' || k === 'j') { e.preventDefault(); this.next(); }
    else if (k === 'ArrowUp' || k === 'PageUp' || k === 'k') { e.preventDefault(); this.prev(); }
    else if (k === 'm' || k === 'M') { e.preventDefault(); this.setMuted(!this.muted); }
    else if ((k === ' ' || k === 'Spacebar') && tag !== 'BUTTON' && tag !== 'A') { e.preventDefault(); var s = this.slides[this.active]; if (s) s.toggle(); }
  };
  Viewer.prototype.pauseForHidden = function () { var s = this.slides[this.active]; if (this.isOpen && s) s.pause(); };
  Viewer.prototype.resumeVisible = function () { var s = this.slides[this.active]; if (this.isOpen && s && !s.userPaused) s.play(); };
  Viewer.prototype.destroy = function () {
    cancelAnimationFrame(this.raf);
    if (this.isOpen) { this.pushed = false; this.unlock(); }
    if (window.LLUgcCore.activeViewer === this) window.LLUgcCore.activeViewer = null;
    if (this.io) this.io.disconnect();
    this.slides.forEach(function (s) { s.unload(); });
    if (this.pop.parentNode) this.pop.parentNode.removeChild(this.pop);
  };

  window.LLUgcCore = {
    reduced: reduced, dataSaver: dataSaver, designMode: designMode, tryPlay: tryPlay, fmt: fmt, safeInsets: safeInsets,
    getJSON: getJSON, setJSON: setJSON, removeStale: removeStale,
    Preview: Preview, Viewer: Viewer, Slide: Slide
  };
})();
